var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charttest"},[_c('div',{ref:"echarts",style:({width: '100%', height: '294px'}),attrs:{"id":_vm.echarts}})])
}
var staticRenderFns = []

export { render, staticRenderFns }